module.exports = __webpack_public_path__ + "assets/b62.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b62.png
// module id = 652
// module chunks = 0